import { render } from "./LandingAccordion.vue?vue&type=template&id=50548945&scoped=true"
import script from "./LandingAccordion.vue?vue&type=script&lang=js"
export * from "./LandingAccordion.vue?vue&type=script&lang=js"

import "./LandingAccordion.vue?vue&type=style&index=0&id=50548945&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50548945"]])

export default __exports__